// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3422T","noInteraction":"EventWrapper_noInteraction__3KCvK"};